import { MedplumClient } from "@medplum/core";

export const submitPracticeCSV = async (medplum: MedplumClient, csv: File): Promise<void> => {
  const csvText = await csv.text();

  await medplum.post(medplum.fhirUrl("$qh-onboard-practice"), {
    csv: csvText,
  });
};
